import { useRef, useEffect, useState, useCallback, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import ModalPopUp from "../SharedComponent/ModalPopUp/ModalPopUp";
import SliderThumb from "../SharedComponent/SliderThumb/SliderThumb";
import CalenderPick from "../SharedComponent/CalenderPick/CalenderPick";
import PrintContent from "../SharedComponent/PrintContent/PrintContent";
import PageCounter from "../SharedComponent/PageCounter/PageCounter";
import {
  sliceOneAdFromPositionerSection,
  DeleteSelectedContentcard,
  submitDbFinal,
  submitDbCleanUp,
  fetchParamsListData,
  fetchDataRequest,
  postEditorialDetailsRequest,
} from "../ReduxState/Actions/actionAd";
import * as constant from "../CONSTANT";
import {
  adsStructure,
  contentStructure,
  defInitialIncrCount,
  editionTypeOption,
  pageNumberArray,
  paperNumberOption,
  templateOption,
  contentpaperNumberOption,
} from "../dataOption";
import "./NewsPaperContentGrid.scss";
import DraggableCard from "../SharedComponent/DraggableCard/DraggableCard";
import ContentCard from "../SharedComponent/ContentCard/ContentCard";
import Draggable from "react-draggable";
import React from 'react'; // Ensure this is present
import { ResizableBox } from "react-resizable";
import html2canvas from 'html2canvas';
import { configure } from "@testing-library/react";


const PAPER_WIDTH = constant.NEWS_PAPER_WIDTH;
const PAPER_HEIGHT = constant.NEWS_PAPER_HEIGHT;

const PAPER_WIDTH_CM = constant.NEWS_PAPER_WIDTH_CM;
const PAPER_HEIGHT_CM = constant.NEWS_PAPER_HEIGHT_CM;

// console.log('PAPER_WIDTH_CM' , PAPER_WIDTH_CM);
// console.log('PAPER_HEIGHT_CM' , PAPER_HEIGHT_CM);

const pageStyleOption = `
@page {
  size: ${PAPER_WIDTH + 35}px ${PAPER_HEIGHT + 55}px;
  margin: 0;
}
@media print {
  body {
    margin: 0;
    padding: 0;
  }
}
`;

const NewsPaperContentGrid = ({ regionVal ,selectedJacketType,selectedFrontPage,setSelectedJacketType,
  setSelectedFrontPage,userSelectedJacket,userSelectedFrontPage, saleType,
}) => {
  const parentRef = useRef(null);
  const verticalScale = Array.from({length: 27},
        (_, i) => 52 - (i * 2));
  const dispatch = useDispatch();
  const metaDataAdPositioned = useSelector(
    (state) => state.dbpostadscombined.adPositionedWithGrid
  );
  useEffect(() => {
    // Clear currently displayed ads/content whenever
    // Main <-> Mini is changed.
    setDraggableAdsPos([]);
    setDraggableContentPos([]);
}, [saleType?.value]);
  useEffect(() => {
    console.log(
        "LOADED SAVED ADS:",
        JSON.stringify(metaDataAdPositioned, null, 2)
    );
}, [metaDataAdPositioned]);
  const { fetchMetaDataInitalDataParams } = useSelector(
    (state) => state.fetchinitialmetadata
  );
  // console.log("metaDataAdPositioned",metaDataAdPositioned)
  const { data } = useSelector((state) => state.data);
  // console.log("data", data);
  const { Summarydata, loading, error } = useSelector((state) => state.summaryDataReducer);
    // console.log('Summarydata', Summarydata)
  const { submitAllAdsLoading, submitAllAdsSuccess, submitAllAdsError } =
    useSelector((state) => state.dbpostadscombined);
  const [draggableAdsPos, setDraggableAdsPos] = useState();
  const [dropDownTypeCriteria, setDropDownTypeCriteria] = useState({
    template: null,
    edition: null,
    page: null,
    paperNumber: null,
    pageNumber: null,
  });
  const [draggableContentPos, setDraggableContentPos] = useState();
  const ContentList = draggableContentPos; // Alias for draggableContentPos
  const [contentdropDownTypeCriteria, setContentDropDownTypeCriteria] = useState({
    template: null,
    edition: null,
    page: null,
    paperNumber: null,
    pageNumber: null,
  });
  const [spaceAllocated, setSpaceAllocated] = useState({
    occupied: "",
    remaining: "",
  });
  const [pageNumberOptions, setPageNumberOptions] = useState([]);
  const [contentpageNumberOptions, setContentPageNumberOptions] = useState([]);
  const [bookMarkOption, setBookMarkOption] = useState([]);
  const [bookMarkValues, setBookMarkValues] = useState({});
  const [initialIncrCount, setInitialIncrCount] = useState(defInitialIncrCount);
  const [pageIncrCount, setPageIncrCount] = useState(initialIncrCount);
  const [pageNumbersArrays, setPageNumbersArray] = useState(pageNumberArray);
  const defTemplateIfNoValue = templateOption[3];
  const defPageIfNoValue = pageNumbersArrays[0];
  const defEditionIfNoValue = editionTypeOption[0];
  const defPaperIFNoValue = paperNumberOption[0];
  const defContentPaperIFNoValue = contentpaperNumberOption[0];
  const [datePostPoner, setDatePostPoner] = useState();
  const [toast, setToast] = useState(false);
  const [userClickedSlider, setUserClickedSlider] = useState(false);
  const [optionTemplate, setOptionTemplate] = useState([]);
  const [isRestoringSavedConfig, setIsRestoringSavedConfig] = useState(false);
  const [savedJacketType, setSavedJacketType] = useState(null);
  const [showPageCountConfirm, setShowPageCountConfirm] = useState(false);
const [pendingPageCount, setPendingPageCount] = useState(null);
  /**
   * check the ads having proper width and height
   * @param {Array<{objects}>} adsArry - accepts array of on objects , in this case draggableAdss
   * @returns {Boolean} - wheather the ads having proper height and width or not
   */
  // const mimicAdsFunc = (adsArry) => {
  //   //in order to show blank slides even the ads not present
  //   const valueBoolean = adsArry?.some((ad) => ad?.width && ad?.height);
  //   return !valueBoolean;
  // };

  const mimicAdsFunc = (adsArry, contentArry) => {
    // const adsValid = adsArry?.some((ad) => ad?.width && ad?.height);
    const valueBoolean = adsArry?.some((ad) => ad?.width && ad?.height);
    const contentValid = contentArry?.some((content) => content?.content_width && content?.content_height);
    return !(valueBoolean && contentValid);
  };
  


 const { editorialDetails } = useSelector((state) => state.editorialReducer);
  useEffect(() => {
    if (data?.length) {
      const transformedContent = data.map((item) => ({
        id: item.id || 0,
        title: item.title,
        content: item.content,
        district_id: item.district_id,
        district_name: item.district_name,
        category_tag_id: item.category_tag_id,
        category_tag_name: item.category_tag_name,
        page_no: item.page_no,
        content_position_x: 0, // Default X position
        content_position_y: 0, // Default Y position
        image_list: item.image_list,
        no_of_cm: item.no_of_cm,
        no_of_column: item.no_of_column,
        no_of_lines: item.no_of_lines,
        publish_dates: item.publish_dates,
        publish_details: item.publish_details,
        editorial_details: item.publish_details, // Pass publish details for nested rendering
      }));
  
      setDraggableContentPos(transformedContent);
    }
  }, [data]);
const bookMarkChange = (val) => {
  const currentPage = dropDownTypeCriteria?.page?.value;

  if (!currentPage) return;

  setBookMarkValues((prev) => ({
    ...prev,
    [currentPage]: val || {},
  }));
};
 const gridPositionValues = useCallback((value) => {
  if (!value?.name) return;

  const GAP = 5;

  setDraggableAdsPos((prev) => {
    if (!Array.isArray(prev)) return prev;

    const movingAd = prev.find(
      (el) => el?.id === value.name
    );

    if (!movingAd) return prev;

    const width = Number(movingAd.width);
    const height = Number(movingAd.height);

    if (!width || !height) return prev;

    const maxX = PAPER_WIDTH - width;
    const maxY = PAPER_HEIGHT - height;

    const proposedX = Math.max(
      0,
      Math.min(Number(value.x) || 0, maxX)
    );

    const proposedY = Math.max(
      0,
      Math.min(Number(value.y) || 0, maxY)
    );

    // Only compare ads belonging to the same page.
    const samePageAds = prev.filter(
      (el) =>
        el?.id !== movingAd.id &&
        String(el?.page) === String(movingAd.page) &&
        Number(el?.width) > 0 &&
        Number(el?.height) > 0
    );

    const isPositionAvailable = (x, y) => {
      return !samePageAds.some((other) => {
        const otherX = Number(other.gridX) || 0;
        const otherY = Number(other.gridY) || 0;
        const otherWidth = Number(other.width);
        const otherHeight = Number(other.height);

        return (
          x < otherX + otherWidth + GAP &&
          x + width + GAP > otherX &&
          y < otherY + otherHeight + GAP &&
          y + height + GAP > otherY
        );
      });
    };

    let bestPosition = null;
    let bestDistance = Infinity;

    // First try the exact position where the user dropped the ad.
    if (isPositionAvailable(proposedX, proposedY)) {
      bestPosition = { x: proposedX, y: proposedY };
    } else {
      // Search the page in 5px increments for the nearest free position.
      const minOffsetX = -Math.ceil(proposedX / GAP) * GAP;
      const maxOffsetX = Math.ceil(
        (maxX - proposedX) / GAP
      ) * GAP;

      const minOffsetY = -Math.ceil(proposedY / GAP) * GAP;
      const maxOffsetY = Math.ceil(
        (maxY - proposedY) / GAP
      ) * GAP;

      for (
        let dx = minOffsetX;
        dx <= maxOffsetX;
        dx += GAP
      ) {
        for (
          let dy = minOffsetY;
          dy <= maxOffsetY;
          dy += GAP
        ) {
          const x = proposedX + dx;
          const y = proposedY + dy;

          if (
            x < 0 ||
            y < 0 ||
            x > maxX ||
            y > maxY
          ) {
            continue;
          }

          const distance = dx * dx + dy * dy;

          if (
            distance < bestDistance &&
            isPositionAvailable(x, y)
          ) {
            bestDistance = distance;
            bestPosition = { x, y };
          }
        }
      }
    }

    // If no free position exists, retain the ad's previous position.
    if (!bestPosition) {
      return prev;
    }

    return prev.map((el) =>
      el?.id === value.name
        ? {
            ...el,
            gridX: bestPosition.x,
            gridY: bestPosition.y,
          }
        : el
    );
  });
}, []);

  const contentgridPositionValues = useCallback((updatedContent) => {
    setDraggableContentPos((prev) =>
      prev.map((el) =>
        el.id === updatedContent.id
          ? {
              ...el,
              ...updatedContent,
              page_no: updatedContent.page_no || el.page_no,
            }
          : el
      )
    );
  }, []);


// const pageCountIncrDecrHandle = useCallback((e, opr) => {
//   e.preventDefault();
//
//   if (opr === "minus") {
//     setInitialIncrCount((prev) => Math.max(prev - 2, 10));
//   }
//
//   if (opr === "plus") {
//     setInitialIncrCount((prev) => prev + 2);
//   }
// }, []);

  const pageCountIncrDecrHandle = useCallback((e, opr) => {
  e.preventDefault();

  const nextInitialCount =
    opr === "minus"
      ? Math.max(initialIncrCount - 2, 10)
      : initialIncrCount + 2;

  // No change required
  if (nextInitialCount === initialIncrCount) return;

  setPendingPageCount({
    oldCount: pageIncrCount,
    newCount: pageIncrCount + (nextInitialCount - initialIncrCount),
    nextInitialCount: nextInitialCount,
  });

  setShowPageCountConfirm(true);

}, [initialIncrCount, pageIncrCount]);



  // const ContentpageCountIncrDecrHandle = useCallback((e, opr) => {
  //   e.preventDefault();
  //   if (opr === "minus") {
  //     setPageIncrCount((prev) =>
  //       pageIncrCount <= defInitialIncrCount ? defInitialIncrCount : prev - 2
  //     );

  //     if (mimicAdsFunc(draggableContentPos)) {
  //       // mimicAds
  //       const _transFormArray = [...draggableContentPos];
  //       _transFormArray?.splice(-2, -2);
  //       setDraggableContentPos(_transFormArray);
  //     }
  //   }
  //   if (opr === "plus") {
  //     setPageIncrCount((prev) => prev + 2);

  //     if (mimicAdsFunc(draggableContentPos)) {
  //       // mimicAds
  //       const _transFormArray = [...draggableContentPos];
  //       _transFormArray?.splice(
  //         draggableContentPos?.length,
  //         0,
  //         { ...contentStructure, page: Number(draggableContentPos?.length + 1) },
  //         { ...contentStructure, page: Number(draggableContentPos?.length + 2) }
  //       );
  //       setDraggableContentPos(_transFormArray);
  //     }
  //   }
  // }, [draggableContentPos, pageIncrCount]);


  const openCloseToast = () => setToast((prev) => !prev);

  // const modalOkClick = (e) => {
  //   e.preventDefault();
  //   dispatch(submitDbCleanUp()); // db
  //   dispatch({ type: "RESET_DATA" });
  //   setDraggableAdsPos([]);
  //   setDraggableContentPos([]);
  //   // console.log("Content cards cleared:", draggableContentPos);
  //   dispatch(fetchDataRequest(regionVal?.value));
  //   setInitialIncrCount(defInitialIncrCount); // pageIncrReset
  //   dispatch(fetchParamsListData(regionVal?.value)); //->to call api again to display updated tableData.
  //   openCloseToast();
  // };

  const modalOkClick = (e) => {
    e.preventDefault();

    dispatch(submitDbCleanUp());
    dispatch({ type: "RESET_DATA" });

    // setInitialIncrCount(defInitialIncrCount);
    dispatch(fetchParamsListData(regionVal?.value));

    openCloseToast();
};

  const adsInsideNewsPaper = (arrList) => {
    const filterAccordingly = arrList?.filter(
      (el) => String(el?.page) === String(dropDownTypeCriteria?.page?.value)
    );
    const defLoadPageValue = "1"; //default pageNo should be assigned for 1 if the new ads not yet positoned
    const filterInSpecialCase = arrList?.filter(
        () => String(defLoadPageValue) === String(dropDownTypeCriteria?.page?.value));
    const adsGotAssignedToPage = !!arrList?.find((el) => el?.page);
    return adsGotAssignedToPage ? filterAccordingly : filterInSpecialCase;
  };
 
  // const contentInsideNewsPaper = (ContentList) => {
  //   const currentPageValue = dropDownTypeCriteria?.page?.value;
  //   if (!Array.isArray(ContentList)) {
  //     // console.error("Expected ContentList to be an array but got:", ContentList);
  //     return [];
  //   }
  //   // Filter only if ContentList is a valid array
  //   return ContentList.filter((el) => el?.page_no === currentPageValue);
  // };

  const contentInsideNewsPaper = (ContentList) => {
    const currentPageValue = contentdropDownTypeCriteria?.page?.value;
    if (!Array.isArray(ContentList)) {
      console.error("Expected ContentList to be an array.");
      return [];
    }
    const filteredContent = ContentList.filter(
        (el) => String(el?.page_no) === String(currentPageValue));
    return filteredContent;
  };
  
  const dateValueFetched = (e) => {
    setDatePostPoner(e);
    const inputDate = new Date(e);
    const formattedDate = inputDate.toISOString().split("T")[0];
    setDraggableAdsPos((prev) =>
      prev?.map((el) => {
        if (el?.page === dropDownTypeCriteria?.page?.value) {
          return {
            ...el,
            _new_publish_date: formattedDate,
          };
        } else {
          return { ...el };
        }
      })
    );
  };

 const contentPostponeDate = (e) => {
    const inputDate = new Date(e);
    const formattedDate = inputDate.toISOString().split("T")[0];
    // Update the datePostPoner state
    setDatePostPoner(inputDate);
    // Update the draggableContentPos state
    setDraggableContentPos((prev) => {
      const updatedPos = prev?.map((el) => {
        if (el?.page_no === contentdropDownTypeCriteria?.page?.value) {
          return {
            ...el,
            _new_publish_date: formattedDate, // Update the postpone date
          };
        }
        return el; // Keep other cards unchanged
      });
      return updatedPos; // Ensure the updated array is returned
    });
  };

  const actionAdMovedToOtherPage = useCallback((arr) => {
    const _draggableAdsPos = [...draggableAdsPos];
    const index = _draggableAdsPos?.findIndex((item) => item?.id === arr?.id);
    _draggableAdsPos?.splice(index, 1, arr);
    setDraggableAdsPos(_draggableAdsPos);
  }, [draggableAdsPos]);
  
  const contentactionMovedToOtherPage = useCallback((updatedContent) => {
    setDraggableContentPos((prev) =>
      prev.map((el) =>
        el.id === updatedContent.id
          ? {
              ...el,
              page_no: updatedContent.page_no || el.page_no, // Keep `page_no` intact
            }
          : el
      )
    );
  }, []);
  
  
  const submitActionDraggablePost = (e) => {
    e.preventDefault();
    openCloseToast();
    const condnCheckPostPoned = (originDate, postPoneDate) => {
      return JSON.stringify(originDate) === JSON.stringify(postPoneDate)
        ? false
        : true;
    };
    const arrayPositionedByUser = draggableAdsPos?.map((el) => {
      console.log('draggableAdsPos el', el)
      return {
        id: el?.id || 0,
        adv_template_id: el?.adv_template_id || dropDownTypeCriteria?.template?.value || 0,
        adv_template_name: el?.adv_template_name || dropDownTypeCriteria?.template?.label,
        ad_type_id: el?.ad_type_id || 0,
        ad_type: el?.ad_type,
        position_id: el?.position_id || 0,
        position_name: el?.position_name,
        size: el?.size,
        ad_template:
          el?.ad_template === templateOption[3].value ? "" : el?.ad_template,
        dummy_chart_position_x: el?.gridX,
        dummy_chart_position_y: el?.gridY,
        page_name: el?.page_name,
        page_id: el?.page_id || 0,
        edition_type: dropDownTypeCriteria?.edition?.value,
        paper_number: dropDownTypeCriteria?.paperNumber?.value,
        page_count: initialIncrCount,
        page: el?.page,
        original_publish_date: el?.publish_date,
        publish_date: el?._new_publish_date,
        postponed_ad: condnCheckPostPoned(
          el?.publish_date,
          el?._new_publish_date
        ),
      };
    });
    dispatch(submitDbFinal(arrayPositionedByUser)); //db
    const contentarrayPositionedByUser = draggableContentPos?.map((el) => {
      // const editorialIds = el.publish_details.map(detail => detail.editorial_id);
      return {
        id: el?.id || 0,
        editorial_id: el?.publish_details?.[0]?.editorial_id || 0,  // Get the first editorial_id from the array
        title: el?.title,
        // content: el?.content,
        content_width: el?.content_width,
        content_height: el?.content_height,
        content_position_x: el?.content_position_x,
        content_position_y: el?.content_position_y,
        page_no: el?.page_no,
        template_id: el?.template_id || contentdropDownTypeCriteria?.template?.value || 0,
        template_name: el?.template_name || contentdropDownTypeCriteria?.template?.label || "",
        original_publish_date: el?.publish_details?.[0]?.publish_date,
        publish_date: el?._new_publish_date,
        // publish_date: el?.publish_details?.[0]?.publish_date ,
        postponed_ad: condnCheckPostPoned(
          el?.publish_date,
          el?._new_publish_date
        ),
      };
    });

    console.log('contentarrayPositionedByUser :', contentarrayPositionedByUser)
    dispatch(postEditorialDetailsRequest(contentarrayPositionedByUser)); //db
  };

  // const dropDownOnChangeEventhandler = (e, targetName) => {
  //   setDropDownTypeCriteria((prev) => ({
  //     ...prev,
  //     [`${targetName}`]: e,
  //   }));

  //   if (targetName === "template") {
    //   const _draggableAdsPos = [...draggableAdsPos];
    //   const _transformedList = _draggableAdsPos?.map((adList) => {
    //     if (adList?.page === dropDownTypeCriteria?.page?.value) {
    //       return {
    //         ...adList,
    //         adv_template_id: e?.value,
    //         adv_template_name: e?.label,
    //       };
    //     } else {
    //       return { ...adList };
    //     }
    //   });
    //   setDraggableAdsPos(_transformedList);
    // }
  // };

  const dropDownOnChangeEventhandler = (e, targetName) => {
    setDropDownTypeCriteria((prev) => ({
      ...prev,
      [`${targetName}`]: e,
    }));
  
    if (targetName === "template" && e) {
      setDraggableAdsPos((prev) =>
        prev?.map((ad) =>
          ad.page === dropDownTypeCriteria?.page?.value
            ? {
                ...ad,
                adv_template_id: e.value,
                adv_template_name: e.label,
              }
            : ad
        )
      );
    }

    setContentDropDownTypeCriteria((prev) => ({
      ...prev,
      [`${targetName}`]: e,
    }));
  
    if (targetName === "template" && e) {
      console.log('setContentDropDownTypeCriteria:', e);
      console.log('targetName:', targetName);
      setDraggableContentPos((prev) =>
        prev?.map((news) =>
          news.page_no === contentdropDownTypeCriteria?.page?.value
            ? {
                ...news,
                  template_id: e.value,
                  template_name: e.label,
              }
            : news
        )
      );
    }

    if (targetName === "page") {
      const contentPageNumber = draggableContentPos?.find(
        (el) => el.page_no === e.value
      );

      // Update `contentdropDownTypeCriteria` specifically
      setContentDropDownTypeCriteria((prev) => ({
        ...prev,
        [targetName]: contentPageNumber
          ? { value: contentPageNumber.page_no, label: `${contentPageNumber.page_no}` }
          : e, // Fallback to selected page
      }));
    }

  };
  
  const deleteTheChildrenInDrags = (e, childValues) => {
    e.preventDefault();
    const payload = {
      deletingId: childValues?.id,
      updatingValues: draggableAdsPos,
    };
    dispatch(sliceOneAdFromPositionerSection(payload)); //db
  };

  const [deletedId, setDeletedId] = useState(null);
  const contentcardDelete = (e, childValues) => {
    e.preventDefault();
    setDraggableContentPos((prev) => prev.filter((item) => item.id !== childValues.id));
    // If Redux is used // Track deleted ID
    setDeletedId(childValues.id);
    const payload = {
      deletingId: childValues?.publish_details?.[0]?.editorial_id,
      updatingValues: draggableContentPos,
    };
    dispatch(DeleteSelectedContentcard(payload));
  };

  useEffect(() => {
    if (deletedId !== null) {
      // Synchronize with other states if needed
      setDraggableContentPos((prev) => prev.filter((item) => item.id !== deletedId));
      setDeletedId(null); // Reset after use
    }
  }, [deletedId]);
  
  const selectionDoneFromSlider = useCallback((val = true) => {
    setUserClickedSlider(val);
  }, []);

  const callBackDropdownchangeHandler = useCallback(
    (fromSlider) => {
      const { page, template } = fromSlider;
      setDropDownTypeCriteria((prev) => ({
        ...prev,
        page,
        template:
          template ??
          optionTemplate?.find((option) => option?.template_default_all),
      }));

      setContentDropDownTypeCriteria((prev) => ({
        ...prev,
        page,
        template:
          template ??
          optionTemplate?.find((option) => option?.template_default_all),
      }));

    },
    [optionTemplate]
  );


  // useEffect(() => {
  //   setDraggableAdsPos(metaDataAdPositioned);
  // }, [metaDataAdPositioned]);

  useEffect(() => {
    if (metaDataAdPositioned || data) {
      setDraggableAdsPos(metaDataAdPositioned);
  
      // Safely set draggableContentPos only if data is an array
      if (Array.isArray(data)) {
        setDraggableContentPos(data);
      } else {
        console.warn("Data is not an array. Resetting draggableContentPos to an empty array.");
        setDraggableContentPos([]);
      }
    }
  }, [metaDataAdPositioned, data]);

useEffect(() => {
  if (
    !Array.isArray(metaDataAdPositioned) ||
    !metaDataAdPositioned.length
  ) {
    setSavedJacketType(null);
    setIsRestoringSavedConfig(false);

    // DON'T RESET initialIncrCount here
    return;
  }

  // Restore only the base page count.
  // Jacket and Front Page are restored from localStorage
  // in FilterFetchForm.jsx.

  const savedPageCounts = metaDataAdPositioned
    .map((el) => Number(el?.page_count) || 0)
    .filter((count) => count > 0);

  if (savedPageCounts.length) {
    const savedPageCount = Math.max(...savedPageCounts);

    console.log(
      "RESTORING SAVED PAGE COUNT:",
      savedPageCount
    );

    setInitialIncrCount(savedPageCount);
  }

  setSavedJacketType(null);
  setIsRestoringSavedConfig(true);

}, [metaDataAdPositioned]);


  useEffect(() => {
    let parentContainerArea = 0;
    let adsoccupiedSpace = 0;
    let parentContainerAreaCm = 0;
    let totalLines = 0;
    let contentoccupiedSpace = 0;

    if (parentRef.current) {
        const containerWidth = PAPER_WIDTH;
        const containerHeight = PAPER_HEIGHT;
        parentContainerArea = containerWidth * containerHeight;

        const containerWidthCm = PAPER_WIDTH_CM; // Width in cm
        const containerHeightCm = PAPER_HEIGHT_CM; // Height in cm
        parentContainerAreaCm = containerWidthCm * containerHeightCm;
        totalLines = parentContainerAreaCm / 3; // Assuming 3 cm per line
    }

    // Calculate Ads Occupied Space
    draggableAdsPos
        ?.filter((el) => String(el?.page) === String(dropDownTypeCriteria?.page?.value))
        ?.forEach((el) => {
            const area = +el?.height * +el?.width;
            adsoccupiedSpace += area;
        });

    // Calculate Content Occupied Space
    draggableContentPos
        ?.filter((el) => el?.page_no === contentdropDownTypeCriteria?.page?.value)
        ?.forEach((el) => {
            console.log('el:', el); // Log the content details for debugging
            const contentWidth = el?.publish_details?.[0]?.content_width || 0;
            const contentHeight = el?.publish_details?.[0]?.content_height || 0;
            const area = contentWidth * contentHeight; // Calculate area in cm²
            contentoccupiedSpace += area;
        });

    // Calculate percentages and remaining space
    let remainingPercentage = 0;
    let remainingCm = 0;
    let occupiedLines = 0;
    let AdsoccupiedColumns = 0;
    let NewsoccupiedColumns = 0;
    let totalColumns = 0;
    const adsoccupiedPercentage = (adsoccupiedSpace / parentContainerArea) * 100;
    // const remainingPercentage = 100 - adsoccupiedPercentage;
    const adsoccupiedCm = (adsoccupiedPercentage / 100) * parentContainerAreaCm;
    // const remainingCm = parentContainerAreaCm - adsoccupiedCm;
    // occupiedLines = adsoccupiedCm / 3;
    totalColumns = PAPER_WIDTH_CM * PAPER_HEIGHT_CM /286;
    // console.log(totalColumns)
    // AdsoccupiedColumns = adsoccupiedCm /286;
    // AdsoccupiedColumns = Math.ceil(AdsoccupiedColumns);

    const remainingLines = totalLines - occupiedLines;
    const contentoccupiedPercentage = (contentoccupiedSpace / parentContainerArea) * 100;
    const contentremainingPercentage = 100 - adsoccupiedPercentage - contentoccupiedPercentage;
    const contentoccupiedCm = (contentoccupiedPercentage / 100) * parentContainerAreaCm;
    const contentremainingCm = parentContainerAreaCm - adsoccupiedCm - contentoccupiedCm;
    const contentoccupiedLines = contentoccupiedCm / 3;
    const contentremainingLines = totalLines - occupiedLines - contentoccupiedLines;
        if(adsoccupiedPercentage){
            remainingPercentage = 100 - adsoccupiedPercentage;
        }else{
            remainingPercentage = 100 - adsoccupiedPercentage - contentoccupiedPercentage;
        }
        if(remainingCm){
          remainingCm = parentContainerAreaCm - adsoccupiedCm;
        }else{
          remainingCm = parentContainerAreaCm - adsoccupiedCm - contentoccupiedCm;
        }
        if(occupiedLines){  
          occupiedLines = adsoccupiedCm / 3;
        }else{ 
          occupiedLines = contentoccupiedCm / 3;
        }

        AdsoccupiedColumns = adsoccupiedCm /286;
        NewsoccupiedColumns = contentoccupiedCm / 286;
        // const remainingColumns = totalColumns - AdsoccupiedColumns - NewsoccupiedColumns;

        const truncatedAdsColumns = Math.floor(AdsoccupiedColumns * 100) / 100; 
        const truncatedNewsColumns = Math.floor(NewsoccupiedColumns * 100) / 100; 
      
        // Dynamically calculate remainingColumns to ensure the total is exactly 6
        const remainingColumns = parseFloat((6 - (truncatedAdsColumns + truncatedNewsColumns)).toFixed(2)); 

    setSpaceAllocated((prev) => ({
        ...prev,
        adsoccupied: Math.round(adsoccupiedPercentage),
        remaining: Math.round(remainingPercentage),
        adsoccupied_cm: Math.round(adsoccupiedCm),
        remaining_cm: Math.round(remainingCm),
        adsoccupied_Lines: Math.round(occupiedLines),
        remaining_Lines: Math.round(remainingLines),

        contentoccupied: Math.round(contentoccupiedPercentage),
        contentremaining: Math.round(contentremainingPercentage),
        contentoccupied_cm: Math.round(contentoccupiedCm),
        contentremaining_cm: Math.round(contentremainingCm),
        contentoccupied_Lines: Math.round(contentoccupiedLines),
        contentremaining_Lines: Math.round(contentremainingLines),
        remainingOverallLines: Math.round(remainingLines),

        // AdsoccupiedColumns: Math.floor(AdsoccupiedColumns * 100) / 100,
        // NewsoccupiedColumns: Math.floor(NewsoccupiedColumns * 100) / 100,
        // remainingColumns:  Math.floor(remainingColumns * 100) / 100,

        AdsoccupiedColumns: truncatedAdsColumns,
        NewsoccupiedColumns: truncatedNewsColumns,
        remainingColumns: remainingColumns,


        // advertisement_no_of_cm: Math.round(advertisement_no_of_cm),
    }));
  }, [draggableAdsPos, draggableContentPos, pageNumbersArrays, dropDownTypeCriteria?.page?.value, contentdropDownTypeCriteria?.page?.value]);
  
  
  
  useEffect(() => {
    const pageNoTransform = fetchMetaDataInitalDataParams?.[0]?.[
      "page_number"
    ]?.map((el) => ({
      label: el?.page_name,
      value: el?.id,
    }));

    const bookMarkTransform = fetchMetaDataInitalDataParams?.[0]?.[
      "page_place_holder"
    ]?.map((el) => ({
      ...el,
      label: el?.name,
      value: el?.id,
    }));
    const optionTemplateTransform = fetchMetaDataInitalDataParams?.[0]?.[
      "adv_template"
    ]?.map((el) => ({
      ...el,
      label: el?.template_name,
      value: el?.template_id,
    }));
    setOptionTemplate(optionTemplateTransform);
    setPageNumberOptions(pageNoTransform);
     setContentPageNumberOptions(pageNoTransform);
    setBookMarkOption(bookMarkTransform);
  }, [fetchMetaDataInitalDataParams]);


  // useEffect(() => {
  //   const pageNoTransform = data?.[0]?.[
  //     "page_number"
  //   ]?.map((el) => ({
  //     label: el?.page,
  //     value: el?.id,
  //   }));

  
  //   const optionTemplateTransform = data?.[0]?.[
  //     "news_template"
  //   ]?.map((el) => ({
  //     ...el,
  //     label: el?.template_name,
  //     value: el?.template_id,
  //   }));
  //   setOptionTemplate(optionTemplateTransform);
  //   setPageNumberOptions(pageNoTransform);
  //    setContentPageNumberOptions(pageNoTransform);
  // }, [data]);

  useEffect(() => {
    if (dropDownTypeCriteria?.edition?.value === "single") {
      setDropDownTypeCriteria((prev) => ({
        ...prev,
        [`paperNumber`]: paperNumberOption[0],
      }));
    }
  }, [dropDownTypeCriteria?.edition]);

// COntent//
  useEffect(() => {
    if (dropDownTypeCriteria?.edition?.value === "single") {
      setDropDownTypeCriteria((prev) => ({
        ...prev,
        [`paperNumber`]: contentpaperNumberOption[0],
      }));
    }
  }, [dropDownTypeCriteria?.edition]);

  useEffect(() => {
    const templatePop = templateOption?.find((el) => {
      const match = metaDataAdPositioned?.find(
        (item) => item?.ad_template === el?.value
      );
      return match;
    });
    const pagePop = pageNumbersArrays?.find((el) => {
      const match = metaDataAdPositioned?.find(
        (item) => item?.page === el?.value
      );
      return match;
    });

    const editionPop = editionTypeOption?.find((el) => {
      const match = metaDataAdPositioned?.find(
        (item) => item?.edition_type === el?.value
      );
      return match;
    });

    const paperPop = paperNumberOption?.find((el) => {
      const match = metaDataAdPositioned?.find(
        (item) => item?.paper_number === el?.value
      );
      return match;
    });

    const pageNumberPop = pageNumberOptions?.find((el) => {
      const match = metaDataAdPositioned?.find(
        (item) => item?.page_id === el?.value
      );
      return match;
    });

    setDropDownTypeCriteria((prev) => ({
      ...prev,
      edition: editionPop ? editionPop : defEditionIfNoValue,
      page: pagePop ? pagePop : defPageIfNoValue,
      paperNumber: paperPop ? paperPop : defPaperIFNoValue,
      template: templatePop ? templatePop : defTemplateIfNoValue,
      pageNumber: pageNumberPop ? pageNumberPop : null,
    }));
  }, [
    defEditionIfNoValue,
    defPageIfNoValue,
    defPaperIFNoValue,
    defTemplateIfNoValue,
    metaDataAdPositioned,
    pageNumberOptions,
    pageNumbersArrays,
  ]);


  // content //

useEffect(() => {
  console.log('object:', templateOption)

    const newstemplatePop = templateOption?.find((el) => {
      const match = data?.find(
        (item) => item?.news_template === el?.value
      );
      return match;
    });
    const pagePop = pageNumbersArrays?.find((el) => {
      const match = Array(data)?.find(  (item) => item?.page_no === el?.value);
      return match;
    });

    const paperPop = contentpaperNumberOption?.find((el) => {
      const match = Array(data)?.find(
        (item) => item?.paper_no === el?.value
      );
      return match;
    });

    const pageNumberPop = contentpageNumberOptions?.find((el) => {
      const match = Array(data)?.find(
        (item) => item?.page_id === el?.value
      );
      return match;
    });

    setContentDropDownTypeCriteria((prev) => ({
      ...prev,
      newstemplate: newstemplatePop ? newstemplatePop : defTemplateIfNoValue,
      page: pagePop ? pagePop : defPageIfNoValue,
      paperNumber: paperPop ? paperPop : defPaperIFNoValue,
      pageNumber: pageNumberPop ? pageNumberPop : null,
    }));
  }, [
    defEditionIfNoValue,
    defPageIfNoValue,
    defPaperIFNoValue,
    defTemplateIfNoValue,
    data,
    contentpageNumberOptions,
    pageNumbersArrays,
  ]);

  

  useEffect(() => {
    if (draggableAdsPos?.length) {
      const adTime = draggableAdsPos?.find(
    (el) => String(el?.page) === String(dropDownTypeCriteria?.page?.value))?._new_publish_date;
      setDatePostPoner(adTime ? new Date(adTime) : new Date());
    }
  }, [dropDownTypeCriteria?.page?.value, draggableAdsPos]);

  useEffect(() => {
    if (!draggableAdsPos?.length) {
      setUserClickedSlider(false);
    }
  }, [draggableAdsPos]);

  // useEffect(() => {
  //   if (draggableContentPos?.length) {
  //     const adTime = draggableContentPos?.find(
  //       (el) => el?.page_no === contentdropDownTypeCriteria?.page?.value
  //     )?._new_publish_date;
  //     setDatePostPoner(adTime ? new Date(adTime) : new Date());
  //   }
  // }, [contentdropDownTypeCriteria?.page?.value, draggableContentPos]);

  useEffect(() => {
    if (draggableContentPos?.length) {
        const adTime = draggableContentPos?.find(
            (el) => el?.page_no === contentdropDownTypeCriteria?.page?.value
        )?._new_publish_date;
        setDatePostPoner(adTime ? new Date(adTime) : datePostPoner);
    }
}, [contentdropDownTypeCriteria?.page?.value, draggableContentPos]);


  useEffect(() => {
    // showcase / a mimic - for slider to have dummy ads in case if the ads are not present.
    if (!draggableAdsPos?.length) {
      //mimicAds
      const _arrayFillTrans = [...pageNumbersArrays]?.map((item, i) => ({
        ...adsStructure,
        page: String(item?.value),
      }));
      setDraggableAdsPos(_arrayFillTrans);
    }
  }, [draggableAdsPos, pageIncrCount, pageNumbersArrays]);
//
// useEffect(() => {
//   if (
//     draggableAdsPos?.length &&
//     !userSelectedJacket &&
//     !savedJacketType &&
//     !selectedFrontPage?.value &&
//     !userSelectedFrontPage
//   ) {
//     const pageCountAmongAds = Math.max(
//       ...draggableAdsPos.map(
//         (el) => Number(el?.page_count) || 0
//       )
//     );
//
//     if (pageCountAmongAds && pageCountAmongAds !== initialIncrCount) {
//       setInitialIncrCount(pageCountAmongAds);
//     }
//   }
// }, [
//   // IMPORTANT: don't depend on draggableAdsPos continuously
//   metaDataAdPositioned,
// ]);

useEffect(() => {
    if (userSelectedJacket && !selectedJacketType?.value) {
        setIsRestoringSavedConfig(false);
        setPageIncrCount(initialIncrCount);
    }
}, [
    userSelectedJacket,
    selectedJacketType,
    initialIncrCount,
]);

  // useEffect(() => {
  //   setPageIncrCount(initialIncrCount);
  // }, [initialIncrCount]);

  // useEffect(() => {
  //   const setPNoArraysByPageCount = () => {
  //     const fillArrObj = Array(pageIncrCount).fill()?.map((_, index) => ({ value: index + 1, label: String(index + 1) }))
  //     setPageNumbersArray(fillArrObj);
  //   };
  //   setPNoArraysByPageCount();
  // }, [pageIncrCount]);

    useEffect(() => {

        let jacketPages = [];
        let jacketCount = 0;

        let frontPages = [];
        let frontCount = 0;

       const effectiveJacketType =
  selectedJacketType?.value || savedJacketType;

switch (effectiveJacketType) {

            case "half_jacket":
                jacketPages = [
                    {value: "I", label: "I"},
                    {value: "II", label: "II"},
                ];
                jacketCount = 2;
                break;

            case "two_half_jacket":
                jacketPages = [
                    {value: "I", label: "I"},
                    {value: "II", label: "II"},
                    {value: "III", label: "III"},
                    {value: "IV", label: "IV"},
                ];
                jacketCount = 4;
                break;
            case "three_half_jacket":
                jacketPages = [
                    {value: "I", label: "I"},
                    {value: "II", label: "II"},
                    {value: "III", label: "III"},
                    {value: "IV", label: "IV"},
                    {value: "V", label: "V"},
                    {value: "VI", label: "VI"},
                ];
                jacketCount = 6;
                break;
            case "four_half_jacket":
                jacketPages = [
                    {value: "I", label: "I"},
                    {value: "II", label: "II"},
                    {value: "III", label: "III"},
                    {value: "IV", label: "IV"},
                    {value: "V", label: "V"},
                    {value: "VI", label: "VI"},
                    {value: "VII", label: "VII"},
                    {value: "VIII", label: "VIII"},
                ];
                jacketCount = 8;
                break;
            case "five_half_jacket":
                jacketPages = [
                    {value: "I", label: "I"},
                    {value: "II", label: "II"},
                    {value: "III", label: "III"},
                    {value: "IV", label: "IV"},
                    {value: "V", label: "V"},
                    {value: "VI", label: "VI"},
                    {value: "VII", label: "VII"},
                    {value: "VIII", label: "VIII"},
                    {value: "IX", label: "IX"},
                    {value: "X", label: "X"},
                ];
                jacketCount = 10;
                break;

            case "full_jacket":
                jacketPages = [
                    {value: "I", label: "I"},
                    {value: "II", label: "II"},
                    {value: "III", label: "III"},
                    {value: "IV", label: "IV"},
                ];
                jacketCount = 4;
                break;

            case "french_window":
                jacketPages = [
                    {value: "FW1", label: "FW1"},
                    {value: "FW2", label: "FW2"},
                    {value: "FW3", label: "FW3"},
                ];
                jacketCount = 3;
                break;

            default:
                jacketPages = [];
                jacketCount = 0;
        }
        const romanNumbers = ["I", "II", "III", "IV", "V", "VI",
            "VII", "VIII", "IX", "X", "XI", "XII",];
        const nextRoman1 = romanNumbers[jacketCount];
        const nextRoman2 = romanNumbers[jacketCount + 1];
         switch (selectedFrontPage?.value) {

           case "two_front_pages":
             frontPages = [
               {value: "FP1", label: "FP1"},
               {value: "1", label: "1"},
               {value: "FP2", label: "FP2"},
               {value: "2", label: "2"},
             ];
             frontCount = 1;
             break;

             case "three_front_pages":
                 frontPages = [
                     {value: "FP1", label: "FP1"},
                     {value: nextRoman1, label: nextRoman1},
                     {value: "FP2", label: "FP2"},
                     {value: nextRoman2, label: nextRoman2},
                     {value: "FP3", label: "FP3"},
                 ];
                 frontCount = 2;
                 break;
            default:
                frontPages = [];
                frontCount = 0;
        }
        let startPage = 1;

         // Only for 2 Front Pages, continue normal pages from 3
if (selectedFrontPage?.value === "two_front_pages") {
    startPage = 3;
}
        // Only for 3 Front Pages skip page 1
        if (selectedFrontPage?.value === "three_front_pages") {
            startPage = 2;
        }

     const normalPageCount = Math.max(
  initialIncrCount,
  0
);

      const normalPages = Array(normalPageCount)
          .fill()
          .map((_, index) => ({
            value: startPage + index,
            label: String(startPage + index),
          }));

        setPageNumbersArray([
            ...jacketPages,
            ...frontPages,
            ...normalPages
        ]);

        // If user selects No Jacket after a restored Half Jacket,
// go back to the default page count.
if (userSelectedJacket && !selectedJacketType?.value) {
  setIsRestoringSavedConfig(false);
  setPageIncrCount(initialIncrCount);
} else {
  setPageIncrCount(
    initialIncrCount + jacketCount + frontCount
  );
}

    }, [selectedJacketType, selectedFrontPage, initialIncrCount, isRestoringSavedConfig,userSelectedJacket,savedJacketType,]);

// console.log('draggableAdsPos .........', draggableAdsPos);

  const GRID_COLUMNS = 8; // Number of grid columns
  const GRID_WIDTH = PAPER_WIDTH / GRID_COLUMNS; // Width of each grid column

  const GRID_HALF = GRID_WIDTH/2;

  const selectedTemplateRef = useRef(dropDownTypeCriteria?.template);
  useEffect(() => {
    if (dropDownTypeCriteria?.template) {
      selectedTemplateRef.current = dropDownTypeCriteria.template;
    }
  }, [dropDownTypeCriteria?.template]);
  
  useEffect(() => {
    setContentDropDownTypeCriteria((prev) => ({
      ...prev,
      ...dropDownTypeCriteria, // Sync all values
    }));
  }, [dropDownTypeCriteria]);
  
  useEffect(() => {
    const currentContentPage = draggableContentPos?.find(
      (el) => el.page_no === dropDownTypeCriteria?.page?.value
    );
  
    if (currentContentPage) {
      setContentDropDownTypeCriteria((prev) => ({
        ...prev,
        pageNumber: {
          value: currentContentPage.page_no,
          label: `${currentContentPage.page_no} Page`,
        },
      }));
    }
  }, [draggableContentPos, dropDownTypeCriteria]);
  const handleDateChange = (e) => {
    // Call the function for ads if ads exist
    if (draggableAdsPos?.length > 0) {
      dateValueFetched(e);
    }
    // Call the function for ContentCard if content exists
    if (draggableContentPos?.length > 0) {
      contentPostponeDate(e);
    }
  };

  const currentPageBookmark =
  bookMarkValues?.[dropDownTypeCriteria?.page?.value] || {};

  return (
    <div className="newsGridWrapper">
      <ModalPopUp
        show={toast}
        contentClassName={"parentModalContentJsx"}
        modalOkClick={modalOkClick}
        submitAllAdsError={submitAllAdsError}
        submitAllAdsLoading={submitAllAdsLoading}
        submitAllAdsSuccess={submitAllAdsSuccess}
      />
      <Modal
  show={showPageCountConfirm}
  onHide={() => setShowPageCountConfirm(false)}
  centered
  backdrop="static"
>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Page Count Change</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p>Are you sure you want to change the page count?</p>

    <p>
      Previous Page Count: <strong>{pendingPageCount?.oldCount}</strong>
    </p>

    <p>
      New Page Count: <strong>{pendingPageCount?.newCount}</strong>
    </p>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => {
        setShowPageCountConfirm(false);
        setPendingPageCount(null);
      }}
    >
      Cancel
    </Button>

    <Button
      variant="primary"
      onClick={() => {
        setInitialIncrCount(pendingPageCount.nextInitialCount);
        setShowPageCountConfirm(false);
        setPendingPageCount(null);
      }}
    >
      Confirm
    </Button>
  </Modal.Footer>
</Modal>
      <>
        <div className="thumnailModule">
          <div>
            <SliderThumb
              newsPages={pageNumbersArrays}
              dropdownCategoryValues={dropDownTypeCriteria}
              contentdropdownCategoryValues={contentdropDownTypeCriteria}
              dropDownChangeFromNewsPaperGrid={callBackDropdownchangeHandler}
              thumbNailAds={draggableAdsPos}
              thumbNailsContent={draggableContentPos} // Pass content data
              userClickDone={userClickedSlider}
              functForUserClick={selectionDoneFromSlider}
              regionSlide={regionVal}
              smTemplate={optionTemplate}
              reasignPosValues={contentgridPositionValues}
            />
          </div>
        </div>

          <div
            className="newsFrame"
            style={{ display: userClickedSlider ? "block" : "none" }}
          >
            <div className="topMenuWrap">

            {/*<div className="sectionWrap adsDetailsWrap" style={{width: "95%"}}>*/}
          {/*  <div className="sectionTitle">Ads Details <span style={{color:"black",fontSize: "large"}}>(Per-Page)</span></div>*/}
          {/*  <div className="spaceDiv"*/}
          {/*    style={{*/}
          {/*      fontSize: "20px",*/}
          {/*      fontWeight: "600",*/}
          {/*      display: "flex",*/}
          {/*      flexDirection: "row",*/}
          {/*      gap: "20px", // Space between elements*/}
          {/*      flexWrap: "wrap", // Wrap elements if they exceed the container's width*/}
          {/*    }}*/}
          {/*  >*/}
          {/*      <span>Ad space: {spaceAllocated?.adsoccupied}%</span>*/}
          {/*      <span>Space Left: {spaceAllocated?.contentremaining}%</span>*/}
          {/*      <span>Ad Sqcm: {spaceAllocated?.adsoccupied_cm} cm</span>*/}
          {/*      <span>Sqcm Left: {spaceAllocated?.remaining_cm} cm</span>*/}
          {/*      <span>Ad  Columns: {spaceAllocated?.AdsoccupiedColumns}</span>*/}
          {/*      <span> Columns Left: {spaceAllocated?.remainingColumns}</span>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {/*<div className="sectionWrap contentDetailsWrap" style={{width: "95%"}}>*/}
          {/*  <div className="sectionTitle">News Details <span style={{color:"black",fontSize: "large"}}>(Per-Page)</span></div>*/}
          {/*  <div className="spaceDiv" */}
          {/*    style={{ */}
          {/*      fontSize:"20px", */}
          {/*      fontWeight:"600",  */}
          {/*      display: "flex",  */}
          {/*      flexDirection: "row", */}
          {/*      gap: "15px",*/}
          {/*      flexWrap: "wrap", }}>*/}
          {/*    <span> News space: {spaceAllocated?.contentoccupied}%</span>*/}
          {/*    <span>Space Left:{" "}{spaceAllocated?.contentremaining}%</span>*/}
          {/*    <span>News Sqcm: {spaceAllocated?.contentoccupied_cm} cm</span>*/}
          {/*    <span>Sqcm Left: {spaceAllocated?.contentremaining_cm} cm</span>*/}
          {/*    <span>News Columns : {spaceAllocated?.NewsoccupiedColumns}</span>*/}
          {/*    <span> Columns Left : {spaceAllocated?.remainingColumns}</span>*/}
          {/*  </div>*/}
          {/*</div>*/}
        {/* {console.log('draggableContentPos?.[0]?.summary_details?.[0]?', draggableContentPos)} */}
        {/*  <div className="sectionWrap summaryDetailsWrap" style={{ width: "95%" }}>*/}
        {/*  <div className="sectionTitle">*/}
        {/*      <div*/}
        {/*        style={{*/}
        {/*          display: "grid",*/}
        {/*          gridTemplateColumns: "repeat(3, 1fr)",*/}
        {/*          textAlign: "left",*/}
        {/*          gap: "10px", // Optional: Adds spacing between columns*/}
        {/*        }}*/}
        {/*      >*/}
        {/*        <span*/}
        {/*          className="summaryTitle"*/}
        {/*          style={{*/}
        {/*            textAlign: "left",*/}
        {/*            fontSize: "20px",*/}
        {/*            fontWeight: "700",*/}
        {/*            color: "black",*/}
        {/*            marginBottom: "-30px",*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          {Summarydata?.[0]?.edition_name   }*/}
        {/*        </span>*/}
        {/*      </div>*/}
        {/*      Summary Details*/}
        {/*    </div>*/}


            {/*<div*/}
            {/*  className="spaceDiv"*/}
            {/*  style={{*/}
            {/*    fontSize: "20px",*/}
            {/*    fontWeight: "600",*/}
            {/*    border: "2px solid black",*/}
            {/*    padding: "10px",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <table*/}
            {/*    style={{*/}
            {/*      width: "100%",*/}
            {/*      borderCollapse: "collapse",*/}
            {/*      textAlign: "center",*/}
            {/*      border: "2px solid black", // Add solid border for the entire table*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    <thead>*/}
            {/*      <tr>*/}
            {/*        /!* Main Headings *!/*/}
            {/*        <th*/}
            {/*          colSpan="3"*/}
            {/*          style={{*/}
            {/*            border: "2px solid black",*/}
            {/*            padding: "10px",*/}
            {/*            backgroundColor: "#f1f1f1",*/}
            {/*          }}*/}
            {/*        >*/}
            {/*        Percentage %*/}
            {/*        </th>*/}
            {/*        <th*/}
            {/*          colSpan="3"*/}
            {/*          style={{*/}
            {/*            border: "2px solid black",*/}
            {/*            padding: "10px",*/}
            {/*            backgroundColor: "#f1f1f1",*/}
            {/*          }}*/}
            {/*        >*/}
            {/*        Sqcm*/}
            {/*        </th>*/}
            {/*        /!* <th*/}
            {/*          colSpan="3"*/}
            {/*          style={{*/}
            {/*            border: "2px solid black",*/}
            {/*            padding: "10px",*/}
            {/*            backgroundColor: "#f1f1f1",*/}
            {/*          }}*/}
            {/*        >*/}
            {/*          Lines*/}
            {/*        </th> *!/*/}
            {/*        <th*/}
            {/*          colSpan="3"*/}
            {/*          style={{*/}
            {/*            border: "2px solid black",*/}
            {/*            padding: "10px",*/}
            {/*            backgroundColor: "#f1f1f1",*/}
            {/*          }}*/}
            {/*        >*/}
            {/*          Columns*/}
            {/*        </th>*/}
            {/*      </tr>*/}

            {/*      /!* Subheadings *!/*/}
            {/*      <tr>*/}
            {/*      <th style={{ border: "2px solid black", padding: "10px" }}>Ads</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px" }}>News</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px", color:"green" }}>Remaining</th>*/}

            {/*        <th style={{ border: "2px solid black", padding: "10px" }}>Ads</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px" }}>News</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px", color:"green"}}>Remaining</th>*/}

            {/*        /!* <th style={{ border: "2px solid black", padding: "10px" }}>Ads</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px" }}>News</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px", color:"green" }}>Remaining</th> *!/*/}

            {/*        <th style={{ border: "2px solid black", padding: "10px" }}>Ads</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px" }}>News</th>*/}
            {/*        <th style={{ border: "2px solid black", padding: "10px", color:"green"}}>Remaining</th>*/}
            {/*      </tr>*/}
            {/*    </thead>*/}

            {/*    <tbody>*/}
            {/*      <tr>*/}
            {/*        /!* Percentages Row *!/*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {((Summarydata?.[0]?.advertisement_percent * 100) || 0)} */}
            {/*          /!* {(Math.floor(Summarydata?.[0]?.advertisement_percent * 100) / 100 || 0)}  *!/*/}

            {/*        </td>*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*        {((Summarydata?.[0]?.editorial_percent * 100) || 0)}   */}
            {/*          /!* {(Math.floor(Summarydata?.[0]?.editorial_percent * 100) / 100 || 0)}  *!/*/}

            {/*        </td>*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*        {((Summarydata?.[0]?.remaining_percent * 100) || 0)}                       */}
            {/*          /!* {(Math.floor(Summarydata?.[0]?.remaining_percent * 100) / 100 || 0)}  *!/*/}
            {/*        </td>*/}

            {/*        /!* CM Row *!/*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {(Math.floor(Summarydata?.[0]?.advertisement_no_of_cm * 100) / 100 || 0)} */}
            {/*        </td>*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {(Math.floor(Summarydata?.[0]?.editorial_no_of_cm * 100) / 100 || 0)} */}
            {/*        </td>*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {(Math.floor(Summarydata?.[0]?.total_space_cm * 100) / 100 || 0)} */}
            {/*        </td>*/}

            {/*        /!* Columns Row *!/*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {(Math.floor(Summarydata?.[0]?.advertisement_no_of_columns * 100) / 100 || 0)} */}
            {/*        </td>*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {(Math.floor(Summarydata?.[0]?.editorial_no_of_columns * 100) / 100 || 0)} */}
            {/*          </td>*/}
            {/*        <td style={{ border: "2px solid black", padding: "10px" }}>*/}
            {/*          {(Math.floor(Summarydata?.[0]?.total_space_column * 100) / 100 || 0)} */}
            {/*        </td>*/}
            {/*      </tr>*/}
            {/*    </tbody>*/}
            {/*  </table>*/}
            {/*</div>*/}
          </div>
            
            {/* <div className="spaceDiv">
              Ad space: {spaceAllocated?.occupied}%,
              News Space:{" "}{spaceAllocated?.remaining}%,
              Ad space: {spaceAllocated?.occupied_cm} cm,
              News Space: {spaceAllocated?.remaining_cm} cm,
              Ad Lines : {spaceAllocated?.occupied_Lines},
              Lines Left : {spaceAllocated?.remaining_Lines}
            </div> */}
            <div className="dropAndBtn">
              <div className="dropWrap">
                <div className="dropTitle">Bookmark page: </div>
                <div className="templateDrop editionTypeDrop bookmark">
                  <Select
  options={bookMarkOption}
  value={currentPageBookmark}
  isClearable
  onChange={(val) => {
    const currentPage = dropDownTypeCriteria?.page?.value;

    if (!currentPage) return;

    setBookMarkValues((prev) => ({
      ...prev,
      [currentPage]: val || {},
    }));
  }}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  styles={{
    control: (base) => ({
      ...base,
      width: "180px",
      minWidth: "180px",
    }),

    container: (base) => ({
      ...base,
      width: "180px",
      minWidth: "180px",
    }),

    menu: (base) => ({
      ...base,
      width: "250px",
      minWidth: "250px",
    }),

    menuList: (base) => ({
      ...base,
      width: "250px",
    }),

    option: (base) => ({
      ...base,
      whiteSpace: "nowrap",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }}
/>

                </div>
                <div className="templateDrop editionTypeDrop">
                  <Select
                    options={pageNumbersArrays}
                    value={dropDownTypeCriteria?.page || contentdropDownTypeCriteria?.page}
                    // value1={contentdropDownTypeCriteria?.page}

                    onChange={(e) => dropDownOnChangeEventhandler(e, "page")}
                  />
                </div>
              </div>
              <div className="dropWrap">
                <div className="dropTitle">Page Count: </div>
                <PageCounter
                    pageCountIncrDecrHandle={pageCountIncrDecrHandle}
                    pageIncrCount={pageIncrCount}
                />
              </div>
              {/*<div className="dropWrap">*/}
              {/*  <div className="dropTitle">Edition Type: </div>*/}
              {/*  <div className="templateDrop editionTypeDrop">*/}
              {/*    <Select*/}
              {/*      options={editionTypeOption}*/}
              {/*      value={dropDownTypeCriteria?.edition}*/}
              {/*      onChange={(e) => dropDownOnChangeEventhandler(e, "edition")}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/*<div className="dropWrap">*/}
              {/*  <div className="dropTitle">Paper Number: </div>*/}
              {/*  <div className="templateDrop paperNumberDrop">*/}
              {/*    <Select*/}
              {/*      options={paperNumberOption}*/}
              {/*      value={dropDownTypeCriteria?.paperNumber}*/}
              {/*      value1={contentdropDownTypeCriteria?.paperNumber}*/}

              {/*      onChange={(e) =>*/}
              {/*        dropDownOnChangeEventhandler(e, "paperNumber")*/}
              {/*      }*/}
              {/*      isDisabled={*/}
              {/*        dropDownTypeCriteria?.edition?.value === "single"*/}
              {/*          ? true*/}
              {/*          : false*/}
              {/*      }*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*</div>*/}
              {
                <div className="dropWrap">
                  <div className="dropTitle">Template: </div>
                  <div className="templateDrop">
                    <Select
                      options={optionTemplate}
                      value={dropDownTypeCriteria?.template}
                      isClearable
                      onChange={(e) =>
                        dropDownOnChangeEventhandler(e, "template")
                      }
                    />
                  </div>
                </div>
              }
              {/*<div className="dropWrap">*/}
              {/*  <div className="dropTitle">Postpone Date: </div>*/}
              {/*  <div className="templateDrop">*/}
              {/*    <CalenderPick*/}
              {/*      id={"advertisementDate"}*/}
              {/*      date={datePostPoner}*/}
              {/*      // changeDate={dateValueFetched}*/}
              {/*      changeDate={*/}
              {/*        handleDateChange*/}
              {/*      }   */}
              {/*    />*/}
              {/*  </div>*/}
              {/*</div>*/}

              <div className="btnSubmit">
                <Button
                  // disabled={
                  //   mimicAdsFunc(draggableAdsPos , draggableContentPos) || submitAllAdsLoading
                    
                  // }
                  onClick={submitActionDraggablePost}
                >
                  Save
                </Button>
              </div>
              <div className="pdfDownLoad" title="Save/print page">
                <PrintContent
                  fileName={`Schedule__${new Date().toLocaleDateString()}__PageNO:${dropDownTypeCriteria?.page?.value
                    }`}
                  refContainer={parentRef?.current}
                  pageOptions={pageStyleOption}
                />
              </div>
          </div>
               </div>

          <div
            ref={parentRef}
            className="parent"
            id="parent"
            style={{
  position: "relative",
  width: `${PAPER_WIDTH}px`,
  height: `${PAPER_HEIGHT}px`,

"--print-info": `"Date: ${
  datePostPoner
    ? new Date(datePostPoner).toLocaleDateString("en-GB")
    : ""
}        | Page Number: ${
  dropDownTypeCriteria?.page?.value || ""
}        | No. of Ads: ${
  adsInsideNewsPaper(draggableAdsPos)?.filter(
    (ad) => ad?.width && ad?.height
  )?.length || 0
}        | Region: ${
  regionVal?.label ||""
}"`,
}}
          >
              <div className="verticalScale">
                  {verticalScale.map((value) => (
                      <div key={value} className="scaleMark">
                          {value}
                      </div>
                  ))}
              </div>

            {/* <div className="templateDesign">
              {dropDownTypeCriteria?.template?.template_image && (
                <img
                  src={`data:image/png;base64,${dropDownTypeCriteria?.template?.template_image}`}
                  alt={dropDownTypeCriteria?.template?.template_name}
                ></img>
              )}
              {dropDownTypeCriteria?.template?.template_default_all && (
                <div className="pageNoLocation">
                  <div className="regn">{regionVal?.label}</div>
                  <div>{dropDownTypeCriteria?.page?.label}</div>
                </div>
              )}
            </div> */}
            {/* {console.log('selectedTemplateRef', selectedTemplateRef?.current)} */}
            <div className="templateDesign">
  {dropDownTypeCriteria?.template?.template_image ? (
    <img
      src={`data:image/png;base64,${dropDownTypeCriteria.template.template_image}`}
      alt={dropDownTypeCriteria?.template?.template_name || "Template"}
    />
  ) : selectedTemplateRef.current?.template_image ? (
    <img
      src={`data:image/png;base64,${selectedTemplateRef.current.template_image}`}
      alt={selectedTemplateRef.current?.template_name || "Template"}
    />
  ) : null}

  {dropDownTypeCriteria?.template?.template_default_all && (
    <div className="pageNoLocation">
      <div className="regn">{regionVal?.label}</div>
      <div>{dropDownTypeCriteria?.page?.label}</div>
    </div>
  )}
</div>


            {currentPageBookmark?.value &&
                currentPageBookmark?.value !== "none" && (
                    <div
                        className="bookMarkOverPage"
                        style={{
                          display: "block",
                        }}
                    >
                      <p>{currentPageBookmark?.label}</p>
                    </div>
                )}


             {/* Grid Overlay */}
             <div
                className="gridOverlay"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "grid",
                  gridTemplateColumns: `repeat(${GRID_COLUMNS}, 1fr)`,
                  pointerEvents: "none",
                }}
              >
                {Array.from({ length: GRID_COLUMNS - 1 }).map((_, index) => (
                  <div
                    key={index}
                    style={{
                      borderRight: "1px dotted blue",
                      height: "100%",
                    }}
                  ></div>
                ))}
              </div>
                {console.log("draggableAdsPos----------", draggableAdsPos)}
            {/* {console.log('adsInsideNewsPaper draggableAdsPos', draggableAdsPos)} */}
            {adsInsideNewsPaper(draggableAdsPos)?.map(
              (el, i) =>
                el?.width &&
                el?.height && 
                (
                  <DraggableCard
                    childValues={el}
                    key={i}
                    reasignPosValues={gridPositionValues}
                    deleteChildDivs={deleteTheChildrenInDrags}
                    afterPageMovedArrUpdate={actionAdMovedToOtherPage}
                    pageNumbersArrays ={pageNumbersArrays}
                  />
                )
            )}
            {/* {console.log('draggableContentPos:', draggableContentPos)} */}

            {contentInsideNewsPaper(draggableContentPos)?.map((el, i) => (
              <ContentCard
                childValues={{
                  ...el,
                  gridX: el?.publish_details?.[0]?.content_position_x || 0,
                  gridY: el?.publish_details?.[0]?.content_position_y || 0,
                }}
                key={el.id || i}
                reasignPosValues={contentgridPositionValues}
                deleteChildDivs={contentcardDelete}
                afterPageMovedArrUpdate={contentactionMovedToOtherPage}
                pageNumbersArrays={pageNumbersArrays}
              />
            ))}
              {/*<div*/}
              {/*    style={{*/}
              {/*        position: "absolute",*/}
              {/*        bottom: "5px",*/}
              {/*        left: "0",*/}
              {/*        right: "0",*/}
              {/*        display: "flex",*/}
              {/*        justifyContent: "space-around",*/}
              {/*        alignItems: "center",*/}
              {/*        zIndex: 9999,*/}
              {/*    }}*/}
              {/*>*/}
              {/*    {[1, 2, 3, 4].map((_, index) => (*/}
              {/*        <React.Fragment key={index}>*/}
              {/*            /!* 8 Color Dots *!/*/}
              {/*            <div*/}
              {/*                style={{*/}
              {/*                    display: "flex",*/}
              {/*                    alignItems: "center",*/}
              {/*                    gap: "2px",*/}
              {/*                }}*/}
              {/*            >*/}
              {/*                {[*/}
              {/*                    "#00cfe8", // Cyan*/}
              {/*                    "#8fd3e8", // Light Cyan*/}
              {/*                    "#ff33cc", // Magenta*/}
              {/*                    "#d46abf", // Light Magenta*/}
              {/*                    "#ffee00", // Yellow*/}
              {/*                    "#d9d96a", // Light Yellow*/}
              {/*                    "#777777", // Gray*/}
              {/*                    "#000000", // Black*/}
              {/*                ].map((color, idx) => (*/}
              {/*                    <div*/}
              {/*                        key={idx}*/}
              {/*                        style={{*/}
              {/*                            width: "14px",*/}
              {/*                            height: "14px",*/}
              {/*                            borderRadius: "50%",*/}
              {/*                            backgroundColor: color,*/}
              {/*                        }}*/}
              {/*                    />*/}
              {/*                ))}*/}
              {/*            </div>*/}

              {/*            /!* Show bar only after first 3 groups *!/*/}
              {/*            {index < 3 && (*/}
              {/*                <div*/}
              {/*                    style={{*/}
              {/*                        width: "75px",*/}
              {/*                        height: "10px",*/}
              {/*                        borderRadius: "2px",*/}
              {/*                        background:*/}
              {/*                            "linear-gradient(to right,#ddd,#bbb,#999,#666,#333,#666,#999,#bbb,#ddd)",*/}
              {/*                        border: "1px solid #999",*/}
              {/*                    }}*/}
              {/*                />*/}
              {/*            )}*/}
              {/*        </React.Fragment>*/}
              {/*    ))}*/}

              {/*    /!* GH Circle *!/*/}
              {/*    <div*/}
              {/*        style={{*/}
              {/*            width: "18px",*/}
              {/*            height: "18px",*/}
              {/*            borderRadius: "50%",*/}
              {/*            border: "1px solid #666",*/}
              {/*            display: "flex",*/}
              {/*            justifyContent: "center",*/}
              {/*            alignItems: "center",*/}
              {/*            fontSize: "8px",*/}
              {/*            fontWeight: "bold",*/}
              {/*            color: "#666",*/}
              {/*        }}*/}
              {/*    >*/}
              {/*    </div>*/}

              {/*    /!* Registration Mark *!/*/}
              {/*    <div*/}
              {/*        style={{*/}
              {/*            fontSize: "18px",*/}
              {/*            fontWeight: "bold",*/}
              {/*            color: "#000",*/}
              {/*            lineHeight: "1",*/}
              {/*        }}*/}
              {/*    >*/}
              {/*        +*/}
              {/*    </div>*/}
              {/*</div>*/}
          {/*</div>*/}
        </div>
      </>
    </div>
  );
};

export default memo(NewsPaperContentGrid);